import type { HRContractType } from '@/api/client'
import { cn } from '@/lib/cn'
import { useTranslation } from 'react-i18next'

interface Props {
  type: HRContractType
  className?: string
}

// ContractTypeBadge uses a weight hierarchy (darkest for CDI, lightest for
// interim/stage) so a team roster stays readable at a glance.
export function ContractTypeBadge({ type, className }: Props) {
  const { t } = useTranslation('hr')
  const styles: Record<HRContractType, string> = {
    cdi: 'bg-primary text-primary-foreground',
    cdd: 'bg-muted-foreground text-foreground',
    stage: 'bg-muted text-foreground',
    apprenticeship: 'bg-muted-foreground text-foreground',
    interim: 'bg-muted text-foreground',
  }
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        styles[type],
        className,
      )}
    >
      {t(`contract_type.${type}`, { defaultValue: type })}
    </span>
  )
}
